import { render, staticRenderFns } from "./BanksFavorite.vue?vue&type=template&id=75b8e377&scoped=true&"
import script from "./BanksFavorite.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BanksFavorite.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BanksFavorite.vue?vue&type=style&index=0&id=75b8e377&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b8e377",
  null
  
)

export default component.exports